import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=68cf8058&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf8058",
  null
  
)

export default component.exports